'use string'

import {
    cardsAnimations,
    cardsCloseMobile,
    cardsCloseWebDesktop,
    cardsFunctionsMobile,
    cardsFunctionsWeb,
    closeMultiCards,
    createUnitCard,
    disableArrowButtons,
    keyButtonState,
    multiCardsLogic, setUnitCardWrapperTemplateGridAreas,
    updateUnitCard,
} from './unitCardFunctions';
import { Buildings, cardsData, isMobile, settingsData } from '../../../settings';
import {
    markSelectedApartments,
    removeSearchContainer,
} from '../../menu/search/search';
import {
    findSelectionAndCrmData,
    isCompareMode,
    isOptionsCardOpened, setCSSVar,
    setParametersDependsOnCanvasArea,
} from '../../../functions';
import { getCurrentLang } from '../../components/langSwitcher/langSwitcher';
import { Amenities } from '../../components/Amenities/Amenities';
import {setOptionsCardPlansBlockHeight} from "../optionsCards";
import {restorePreviouslyUnitCardPosition} from "../cardsAnimation";

export class UnitCardClass {
    static cards = [];

    constructor(object) {
        this.engineId = object.engineId;
        this.status = object.status;
        this.bmbyPropID = object.bmbyPropID;
        this.buildingEngineId = object.buildingEngineId;
        this.buildingName = object.buildingName;
        this.floor = object.floorNum;
        this.propNum = object.propNum;
        this.propType = object.propType;
        this.price = object.salePrice;
        this.selectedProperty = object.selectedProperty;
        this.infoPoints = {
            balconySize: object.balconySize,
            bathRooms: object.bathRooms,
            gardenSize: object.gardenSize,
            propType: object.propType,
            toilets: object.toilets,
            roomNum: object.roomNum,
            totalSpace: object.totalSpace,
            facing: object.facing,
            modelName: object.modelName,
            accessible: object.accessible,
            treatmentRoom: object.treatmentRoom,
            roofBalconySize: object.roofBalconySize,
            coveredBalconySize: object.coveredBalconySize,
            basementSize: object.basementSize,
            propPricePerSqm: object.propPricePerSqm,
            tenantPrice: object.tenantPrice,
            storages: Boolean(object?.storage) ? object.storage : object.storages,
            parkings: Boolean(object?.parking) ? object.parking : object.parkings
        };
        this.plans = {
            plan2D: object.assets.plan2D,
            plan2DVertical: object.assets.plan2DVertical,
            preview2D: object.assets.preview2D,
            tours360: object.assets.tours360,
            sample360: object.assets.sample360,
            vantage: object.assets.vantage,
            gallery: object.assets.gallery
        }
    }

    createCard() {
        const currentCard = UnitCardClass.findCard();
        if (UnitCardClass.cards.length <= 2 && cardsData.multiplyCards || !currentCard.html) {
            createUnitCard(this);
        } else {
            this.updateCard();
        }

        if (!isMobile) {
            const searchItem = document.querySelector(`li.search__result-item:not(.similar-item)[data-engineid=${this.engineId}]`);
            if (searchItem) {
                searchItem.classList.add('active');
                searchItem.classList.add('active-card');
                searchItem.scrollIntoView({
                    behavior: 'smooth',
                    block: 'center',
                });
            }
        }

        const search = document.querySelector('.search__container-main');
        search && search.setAttribute('mobile-state', 'minimized');
        setParametersDependsOnCanvasArea('building-switcher');
        setUnitCardWrapperTemplateGridAreas();
        setOptionsCardPlansBlockHeight();
        if (!isMobile)
            Amenities.hide();
        // IntersectionLegenda.updatePosition();
    }

    compareCardToBuilding() {
        const buildingId = this.engineId.split('_')[0];
        const activeBuilding = Buildings.getActiveBuilding();
        const keyPlanBtn = this.html.querySelector('.unit-card__button-key-plan');
        const selection = findSelectionAndCrmData(this.engineId).selectedMesh;

        if (activeBuilding.name === buildingId) {
            keyPlanBtn && keyPlanBtn.removeAttribute('disabled');
            this.html.classList.remove('card-from-another-building');
            selection.userData.isClicked = true;
            const internal = setInterval(() => {
                if (!settingsData.activeModeSwitching) {
                    clearInterval(internal);
                    setTimeout(() => {
                        markSelectedApartments(this.engineId);
                    },500);
                }
            },100)
        } else {
            this.html.classList.add('card-from-another-building');
            selection.userData.isClicked = false;
            keyPlanBtn && keyPlanBtn.setAttribute('disabled',true);
        }
    }

    async updateCard() {
        // const currentCard = UnitCardClass.findCard();
        if (isMobile) {
            // await closeUnitCardAnimation(currentCard.html, 'update');
            updateUnitCard(this);
            // await unitCardOpenAnimation();
        } else {
            const currentActiveCard = document.querySelector('.search__result-item.active.active-card');
            if (currentActiveCard)
                currentActiveCard.classList.remove('active', 'active-card');

            updateUnitCard(this);
        }
    }

    setNode(node) {
        this.html = node;
    }

    static findCard(id, className) {
        if (className)
            return UnitCardClass.cards.find(card => card.html.classList.contains(className));

        if (!id)
            return UnitCardClass.cards[0];

        return UnitCardClass.cards.find(card => card.engineId === id);
    }

    setAnimationsToCard() {
        cardsAnimations.apply(this);
    }

    setFunctionsToWebCard() {
        if (isMobile) return;
        cardsFunctionsWeb.apply(this)
    }

    setFunctionsToMobileCard() {
        if (!isMobile) return;
        cardsFunctionsMobile();
    }

    static async closeMobileCard() {
        if (UnitCardClass.cards.length < 1)
            return;

        await cardsCloseMobile();
        setParametersDependsOnCanvasArea('building-switcher');
    }

    closeWebOrDesktopCard(card, id) {
        cardsCloseWebDesktop(card, id);
    }

    setFunctionsToMultiCards(card) {
     multiCardsLogic(card)
    }

    setKeyPlanButtonState(card) {
       keyButtonState(card);
    }

    static changeTowerNameWhenLanguageSwitching(){
        if (!UnitCardClass.cards.length) return;

        const activeBuildingTowerName = Buildings.getActiveBuilding().info.towerName;

        let name;

        if (Array.isArray(activeBuildingTowerName)){
            name = activeBuildingTowerName.find(name => name.lang === getCurrentLang()).value;
        } else {
            name = activeBuildingTowerName;
        }

        UnitCardClass.cards.forEach(card =>{
            const cardTowerName = card.html.querySelector('.card__tower-name');
            if (cardTowerName)
                cardTowerName.textContent = name;
        });
    }

    static activateMutliCardsMode(target) {
        cardsData.multiplyCards = true;
        const card = UnitCardClass.findCard();
        card.html.classList.add('active');
        target.classList.add('active');

        disableArrowButtons();
    }

    static deactivateMutliCardsMode(target) {
        cardsData.multiplyCards = false;
        const cardActive = UnitCardClass.findCard(false, 'active');
        const cardNonActive = UnitCardClass.findCard(false, 'non-active');
        target ? target.classList.remove('active') : null;
        cardActive ? cardActive.html.classList.remove('active') : null;

        disableArrowButtons();

        if (cardNonActive) {
            const cardNonActiveId = cardNonActive.html.getAttribute('data-engineid');
            cardNonActive.closeWebOrDesktopCard(cardNonActive.html, cardNonActiveId);
        }
    }

    static closeMultipleCards() {
        closeMultiCards();
    }

    static applyOptionsCardRules() {
        if (isCompareMode() || UnitCardClass.cards.length > 1)
            return;

        const currentCard = UnitCardClass.findCard();
        if (currentCard) {
            setTimeout(() => {
                currentCard.html.style.paddingBottom = 0;
            }, 100);
        }
    }

    static setUnitCardHeightIntoCssVar() {
        const unitCard = UnitCardClass.findCard();
        let unitCardHeight;
        if (!unitCard) {
            unitCardHeight = 0;
        } else {
            const currentCardElement = unitCard.html;
            unitCardHeight = currentCardElement.getBoundingClientRect().height;
        }
        // document.querySelector(':root').style.setProperty('--unitCardHeight', `${unitCardHeight}px`);
        setCSSVar('--unitCardHeight', `${unitCardHeight}px`);
    }

    static clearInlineStyles() {
        const currentCard = UnitCardClass.findCard();
        if (currentCard)
            currentCard.html.removeAttribute('style');
    }

    static createCard(crmData) {
        const newCard = new UnitCardClass(crmData);
        UnitCardClass.cards.push(newCard);
        newCard.createCard();
    }

    static changeCurrentCardPosition() {
        if (!isMobile || !UnitCardClass.findCard())
            return;

        const currentCardHtmlElement = UnitCardClass.findCard().html;
        if (isOptionsCardOpened()) {
            setTimeout(() => {
                currentCardHtmlElement.style.marginBottom = 0;
                currentCardHtmlElement.style.marginRight = 0;
            }, 100);
        }
    }

    static isAnyCardOpened() {
        return Boolean(UnitCardClass.cards.length > 0);
    }
}
